import { useParams } from "react-router";

import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import Box from "ds/components/Box";
import NotFoundPage from "components/error/NotFoundPage";
import PageLayoutSkeleton from "components/PageLayoutSkeleton";
import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import useErrorHandle from "hooks/useErrorHandle";
import { AccountContext } from "views/AccountWrapper";
import useFlowsProject from "shared/Flows/Projects/useFlowsProject";

import FlowsProjectDetailsRoles from "./Roles";

const FlowsProjectDetails = () => {
  const { projectId = "" } = useParams<{ projectId: string }>();
  const { viewer } = useTypedContext(AccountContext);

  const { project, loading, hasData, error } = useFlowsProject({ projectId });

  useTitle(project ? `Flows · ${project.name}` : "Flows");

  useBreadcrumbs(
    [
      {
        title: "Flows",
        link: "/flows",
      },
      {
        title: project?.name ?? "",
      },
    ],
    [project?.name]
  );

  const ErrorContent = useErrorHandle(error);
  if (ErrorContent) {
    return ErrorContent;
  }

  // The Flows projects area exposes every project, so it is account-admin only.
  if (!viewer.admin) {
    return <NotFoundPage />;
  }

  if (loading && !hasData) {
    return <PageLayoutSkeleton />;
  }

  if (!project) {
    return <NotFoundPage />;
  }

  return (
    <>
      <ViewHeader firstLevel>
        <Box fullWidth justify="between" align="center">
          <ViewHeaderTitle tag="h2">{project.name}</ViewHeaderTitle>
        </Box>
      </ViewHeader>

      <FlowsProjectDetailsRoles projectId={projectId} />
    </>
  );
};

export default FlowsProjectDetails;
